import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import APIExtensions from "../yoello-lib/modules/API/APIDefs";
import useAPI, { IMessageOptions } from "../yoello-lib/modules/API/useAPI";
// import { useAuth0 } from "../yoello-lib/modules/auth/Auth0";
import { IReduxAppState } from "../reducers";
import { useAuthenticationContext } from "../yoello-lib/modules/auth/AuthenticationContext";

interface IUsePollProps {
    APIExtension: APIExtensions;
    messageOptions: IMessageOptions | null;
    disabled?: boolean;
    intervalTime?: number;
    /** If set to true, a value will be fetched immediately */
    triggerOnMount?: boolean;
    refreshList?: boolean;
    dependencies: any[];
    transformFunction?: Function;
    setRefreshList?: (refreshList: boolean) => void;
}

export function usePollAPI<T>({
    APIExtension,
    messageOptions,
    dependencies,
    transformFunction,
    disabled = false,
    intervalTime = 30,
    triggerOnMount = false,
    refreshList = false,
    setRefreshList
}: IUsePollProps) {
    const { retrieveAccessToken } = useAuthenticationContext();
    const { callAPI } = useAPI<T[]>(APIExtension, retrieveAccessToken, { onMountDisabled: !triggerOnMount, ...messageOptions });
    const [returnData, setReturnData] = useState<any>({ });
    const ref = useRef<any>();

    const refreshOrder = useSelector((state: IReduxAppState) => state.general.refreshOrder) || 0;

    useEffect(() => {
        if (!messageOptions) {
            return;
        }
        if (disabled) {
            if (ref.current) {
                clearInterval(ref.current);
            }
            return;
        }

        const handleAPIInterval = async () => {
            const response = await callAPI(HTTPMethods.GET, messageOptions);
            if (response !== undefined) {
                let data = response;
                if (transformFunction) {
                    data = transformFunction(response);
                }
                setReturnData(data);
            }
        }

        handleAPIInterval();

        if (refreshList) {
            if (setRefreshList) {
                setRefreshList(false);
            }
            return;
        }
        if (!ref.current) {
            ref.current = setInterval(handleAPIInterval, intervalTime * 1000);
        } else {
            clearInterval(ref.current);
            ref.current = setInterval(handleAPIInterval, intervalTime * 1000);
        }
        return () => {
            clearInterval(ref.current);
        }
        // eslint-disable-next-line
    }, [JSON.stringify(dependencies), refreshOrder, refreshList]);
    // disabled, messageOptions]);
    // function 
    return returnData;
}